import React from 'react';

import { HandleSelectedWeekDatepicker } from '../shared/CustomDatepickerHeader';

class CustomTimeInput extends React.Component {
    render() {
        const { value, onChange, onClick } = this.props;

        async function handleClick() {
            await onClick();
            HandleSelectedWeekDatepicker();
        }

        return (
            <div className='input-group'>
                <div className='input-group-prepend'>
                    <div className='btn btn-outline-secondary' onClick={handleClick}>
                        <span className='oi oi-calendar'></span>
                    </div>
                </div>
                <input
                    value={value}
                    disabled
                    onChange={(e) => onChange(e.target.value)}
                    className='form-control'
                    onClick={handleClick}
                    style={{ height: 'auto' }}
                />
            </div>
        );
    }
}

export default CustomTimeInput;
